import React, { useState } from 'react'
import { Modal } from '@clickcease/cc-client-components-lib'

import { useTranslation } from 'react-i18next'
import { CROSSALE_STEPS, CrossaleSteps, DomainToSelect } from './CrossSaleModal.types'
import { useSteps } from 'Hooks/useSteps'
import { useAppStore } from 'Stores/appStoreModuleFed'
import { SetupDomains } from './steps/SetupDomains'
import { SelectDomains } from './steps/SelectDomains/SelectDomains'
import { GlobalModals, GLOBAL_MODALS } from 'Types/GlobalModal'

export const CrossSaleModal = ({ modalType }: { modalType: GlobalModals }) => {
  const { t } = useTranslation('general')
  const { setModalToShow } = useAppStore()
  const [selectedDomains, setSelectedDomains] = useState<DomainToSelect[]>([])
  const { setStep, currentStep } = useSteps<CrossaleSteps>(CROSSALE_STEPS.SELECT_DOMAINS)
  const isBotMitigation = modalType === GLOBAL_MODALS.BM_CROSS_SALE
  const notConnectedDoamins = selectedDomains.filter((domain) => !domain.botZappingPluginActivated)

  const closeModal = () => setModalToShow('')

  const getTitleForStep = () => {
    switch (currentStep) {
      case CROSSALE_STEPS.SELECT_DOMAINS:
        return isBotMitigation
          ? t('crossSaleModal.bmAddDomainTitle')
          : t('crossSaleModal.pmAddDomainTitle')
      case CROSSALE_STEPS.SETUP_DOAMINS:
        return t('crossSaleModal.setupDomainsTitle')
      default:
        return t('crossSaleModal.addDomainTitle')
    }
  }

  const onSetStep = (step: CrossaleSteps) => () => setStep(step)

  const setDoaminsAndNextStep = (domains: DomainToSelect[]) => {
    setSelectedDomains(domains)
    onSetStep(CROSSALE_STEPS.SETUP_DOAMINS)()
  }

  const renderSteps = () => {
    switch (currentStep) {
      case CROSSALE_STEPS.SELECT_DOMAINS:
        return (
          <SelectDomains isBotMitigation={isBotMitigation} onNextStep={setDoaminsAndNextStep} />
        )
      case CROSSALE_STEPS.SETUP_DOAMINS:
        return (
          <SetupDomains
            isBotMitigation={isBotMitigation}
            onDone={closeModal}
            domains={notConnectedDoamins}
          />
        )
      default:
        return (
          <SelectDomains isBotMitigation={isBotMitigation} onNextStep={setDoaminsAndNextStep} />
        )
    }
  }

  return (
    <Modal
      title={getTitleForStep()}
      isOpen={true}
      onOpenChange={closeModal}
      onCloseClick={closeModal}
    >
      {renderSteps()}
    </Modal>
  )
}
